import React, { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";

import Login from "./../Modal/Auth/Login";
import Register from "./../Modal/Auth/Register";
import ForgotPassword from "../Modal/Auth/ForgotPassword";
import { useAuth } from "../../context/AuthContext";

const Navbar = (props) => {
  const { user, signOut } = useAuth();
  const [toogleMenu, setToogleMenu] = useState(false);

  const [modalLogin, setModalLogin] = useState(false);
  const onCLickModalLogin = () => {
    setModalLogin((v) => !v);
    document.body.classList.toggle("modal-open", !modalLogin);
  };

  const [modalRegister, setModalRegister] = useState(false);
  const onCLickModalRegister = () => {
    setModalRegister((v) => !v);
    document.body.classList.toggle("modal-open", !modalRegister);
  };

  const [modalForgotPassword, setModalForgotPassword] = useState(false);
  const onCLickModalForgotPassword = () => {
    setModalForgotPassword((v) => !v);
    document.body.classList.toggle("modal-open", !modalForgotPassword);
  };

  const closeAll = () => {
    setModalLogin(false);
    setModalRegister(false);
    setModalForgotPassword(false);
    document.body.classList.remove("modal-open");
  };

  const onCLickSwitchModal = (e) => {
    if (e === "login") {
      closeAll();
      setTimeout(() => { setModalLogin(true); document.body.classList.add("modal-open"); }, 300);
      return;
    }
    if (e === "register") {
      closeAll();
      setTimeout(() => { setModalRegister(true); document.body.classList.add("modal-open"); }, 300);
      return;
    }
    if (e === "forgotPassowrd") {
      closeAll();
      setTimeout(() => { setModalForgotPassword(true); document.body.classList.add("modal-open"); }, 300);
      return;
    }
  };

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <Fragment>
      <Login
        modalLogin={modalLogin}
        onCLickModalLogin={onCLickModalLogin}
        onCLickSwitchModal={onCLickSwitchModal}
      />
      <Register
        modalRegister={modalRegister}
        onCLickModalRegister={onCLickModalRegister}
        onCLickSwitchModal={onCLickSwitchModal}
      />
      <ForgotPassword
        modalForgotPassword={modalForgotPassword}
        onCLickModalForgotPassword={onCLickModalForgotPassword}
        onCLickSwitchModal={onCLickSwitchModal}
      />

      {/* Mobile side nav */}
      <div className={"wrapper__side-nav-mobile d-flex d-lg-none " + (toogleMenu ? "active" : "")}>
        <div className="d-flex flex-wrap w-100">
          <div className="w-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <NavLink to="/" exact className="navbar-brand font__size--24 text__24-1024 semi-bold color__black">
                <img src="./../images/Listopagologo.png" alt="Logo ListoPago" style={{ width: "50px", height: "50px" }} />
              </NavLink>
              <img src="./../images/clsoe2.png" onClick={() => setToogleMenu(!toogleMenu)} className="pointer" alt="" />
            </div>
            <div className="menu">
              <NavLink to="/" exact className="medium font__size--14 text__14-1024 color__black">Inicio</NavLink>
              <hr />
              <NavLink to="/about" className="medium font__size--14 text__14-1024 color__black">Nosotros</NavLink>
              <hr />
              <NavLink to="/planes" className="medium font__size--14 text__14-1024 color__black">Planes</NavLink>
              <hr />
              <NavLink to="/faq" className="medium font__size--14 text__14-1024 color__black">Soporte</NavLink>
              <hr />
              {user ? (
                <>
                  <NavLink
                    to="/perfil"
                    onClick={() => setToogleMenu(false)}
                    className="medium font__size--14 text__14-1024 color__black"
                  >
                    Tu perfil
                  </NavLink>
                  <hr />
                  <button
                    onClick={handleSignOut}
                    className="medium font__size--14 text__14-1024 btn btn__purple color__white shadow ml-auto text-capitalize rounded__12 px-4"
                  >
                    Cerrar sesión
                  </button>
                </>
              ) : (
                <button
                  onClick={() => { setToogleMenu(false); onCLickModalLogin(); }}
                  className="medium font__size--14 text__14-1024 btn btn__purple color__white shadow ml-auto text-capitalize rounded__12 px-4"
                >
                  Iniciar sesión
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="bg__wrap-menu d-lg-none" onClick={() => setToogleMenu(!toogleMenu)}></div>

      {/* Desktop navbar */}
      <nav
        className="navbar navbar-expand-lg bg__black-2 wrapper__navbar position-relative z-2"
        data-aos="fade-down"
        data-aos-duration="1000"
        data-aos-delay="300"
      >
        <div className="container position-relative">
          <NavLink to="/" exact className="navbar-brand font__size--24 text__24-1024 semi-bold color__black">
            <img src="./../images/Listopagologo.png" alt="Logo ListoPago" style={{ width: "100px", height: "auto" }} />
          </NavLink>

          <div className="collapse navbar-collapse wrapper__navbar-menu ml-lg-5" id="navbarSupportedContent">
            <ul className="navbar-nav menu__center">
              <li className="nav-item">
                <NavLink to="/" exact className="nav-link medium font__size--18 text__14-1024 color__black opacity__7 text-capitalize hover">Inicio</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/about" className="nav-link medium font__size--18 text__14-1024 color__black opacity__7 text-capitalize hover">Nosotros</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/planes" className="nav-link medium font__size--18 text__14-1024 color__black opacity__7 text-capitalize hover">Planes</NavLink>
              </li>
              <li className="nav-item">
                <NavLink to="/faq" className="nav-link medium font__size--18 text__14-1024 color__black opacity__7 text-capitalize hover">Soporte</NavLink>
              </li>
            </ul>
          </div>

          <div onClick={() => setToogleMenu(!toogleMenu)} className="nav__button d-lg-none position-relative ml-auto flex-shrink-0">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <div className="d-none d-lg-flex align-items-center" style={{ gap: "10px" }}>
            {user ? (
              <>
                <NavLink
                  to="/perfil"
                  className="medium font__size--14 text__14-1024 btn color__purple text-capitalize rounded__12 px-3 text-decoration-none"
                  style={{ border: "2px solid", background: "transparent" }}
                >
                  Tu perfil
                </NavLink>
                <button
                  onClick={handleSignOut}
                  className="medium font__size--14 text__14-1024 btn btn__purple color__white shadow text-capitalize rounded__12 px-4"
                  style={{ border: "none" }}
                >
                  Cerrar sesión
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={onCLickModalLogin}
                  className="medium font__size--14 text__14-1024 btn color__purple text-capitalize rounded__12 px-3"
                  style={{ border: "2px solid", background: "transparent" }}
                >
                  Iniciar sesión
                </button>
                <a
                  href="https://play.google.com/store/apps/details?id=com.listopago.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="medium font__size--14 text__14-1024 btn btn__purple color__white shadow text-capitalize rounded__12 px-4 text-decoration-none"
                >
                  Prueba Gratis
                </a>
              </>
            )}
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

export default Navbar;
